// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const templateSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  templateType: z.string().max(200),
  name: z.string().max(500),
  content: z.string().max(100000),
  version: z.string().max(200),
  isDefault: z.boolean(),
  data: z.record(z.string(), z.unknown()).optional(),
  tenantId: z.string().max(100).optional(),
})

export type TemplateInput = z.infer<typeof templateSchema>
